// import React, { useEffect, useState } from "react";
// import CommonDataTable from "../../components/CommonDataTable";

// const columns = [

//     { field: "itemCategory", headerName: "Item Category" },
//     { field: "itemSubCategory", headerName: "Sub Category" },
//     { field: "returnWindowDays", headerName: "Return Window" },
//     { field: "exchangeWindowDays", headerName: "Exchange Window" },
//     { field: "createdBy", headerName: "Created By" },
//     { field: "createdDate", headerName: "Created Date" }

// ];

// export default function ReturnMDList({
//     returnData,
//     page,
//     pageSize,
//     setPage,
//     setPageSize,
//     onCreateClick,
//     onView,
//     onEdit,
//     onRefresh
// }) {

//     const [rows, setRows] = useState([]);
//     const [total, setTotal] = useState(0);

//     useEffect(() => {

//         if (returnData?.data) {

//             const formatted = returnData.data.map(item => ({
//                 id: item._id,
//                 ...item,
//                 __original: item
//             }));

//             setRows(formatted);
//             setTotal(returnData.meta?.total || 0);

//         }

//     }, [returnData]);

//     return (

//         <CommonDataTable

//             checkboxSelection
//             allPossibleColumns={columns}
//             initialVisible={columns.map(c => c.field)}
//             initialRows={rows}

//             showCreateButton
//             createButtonText="Create Return Rule"
//             onCreateClick={onCreateClick}

//             page={page}
//             pageSize={pageSize}
//             rowCount={total}

//             onPageChange={setPage}
//             onPageSizeChange={(s) => {
//                 setPageSize(s);
//                 setPage(0);
//             }}

//             onDataRefresh={onRefresh}

//         />

//     );

// }





import React, { useEffect, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../components/CommonDataTable";

export default function ReturnMDList({
    returnData,
    page,
    pageSize,
    setPage,
    setPageSize,
    onCreateClick,
    onView,
    onEdit,
    onRefresh
}) {

    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);

    /* ================= MENU COMPONENT ================= */
    const RowMenu = ({ row }) => {

        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        return (
            <>
                <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <MoreVertIcon />
                </IconButton>

                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem
                        onClick={() => {
                            onView(row.__original);
                            setAnchorEl(null);
                        }}
                    >
                        View
                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            onEdit(row.__original);
                            setAnchorEl(null);
                        }}
                    >
                        Edit
                    </MenuItem>
                </Menu>
            </>
        );
    };

    /* ================= COLUMNS ================= */
    const columns = [

        {
            field: "actions",
            headerName: "",
            sortable: false,
            width: 80,
            renderCell: (params) => <RowMenu row={params.row} />
        },
        { field: "itemCategory", headerName: "Item Category" },
        { field: "itemSubCategory", headerName: "Sub Category" },
        { field: "returnWindowDays", headerName: "Return Window" },
        { field: "exchangeWindowDays", headerName: "Exchange Window" },
        { field: "createdBy", headerName: "Created By" },
        { field: "createdDate", headerName: "Created Date" },
        { field: "updatedBy", headerName: "Updated By" },
        { field: "updatedDate", headerName: "Updated Date" },
      
    ];

    /* ================= DATA ================= */
    useEffect(() => {
        if (returnData?.data) {

            const formatted = returnData.data.map(item => ({
                id: item._id,
                ...item,
                __original: item
            }));

            setRows(formatted);
            setTotal(returnData.meta?.total || 0);
        }
    }, [returnData]);

    return (
        <CommonDataTable
            checkboxSelection
            allPossibleColumns={columns}
            initialVisible={columns.map(c => c.field)}
            initialRows={rows}

            showCreateButton
            createButtonText="Create Return Rule"
            onCreateClick={onCreateClick}

            page={page}
            pageSize={pageSize}
            rowCount={total}

            onPageChange={setPage}
            onPageSizeChange={(s) => {
                setPageSize(s);
                setPage(0);
            }}

            onDataRefresh={onRefresh}
        />
    );
}